<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <!-- <div class="  px-container" style="background-color: #7e83e0;color: #fff;    margin-top: -90px;">
    <div class="c-text-between c-text-both" style="padding: 8px;">
      <div>我们正在从 github.com/frankaemika 迁移至 github.com/frankarobotics。</div>
      <a style="border: 2px solid #fff;padding: 4px 20px;cursor: pointer;border-radius: 5px;" class="newBack" href="https://www.franka-community.de/login" target="_blank">了解更多</a> 
    </div> 
  </div> -->
  <div class="c-text-column" style="    position: relative;top: -90px;">
    <div class="  px-container c-mb-20" style="background-color: #7e83e0;color: #fff;z-index: 2;">
      <div class="c-text-between c-text-both" style="padding: 8px;">
       <div>系统映像 v5.10 现已推出</div>
        <a style="border: 2px solid #fff;padding: 4px 20px;cursor: pointer;border-radius: 5px;" class="newBack"
           @click="$router.push('/products/franka-research-3#system-image')" target="_blank">了解更多</a>
      </div>
      <!-- /franka-research-3#system-image -->
    </div>
    <div class="c-text-between px-container c-flex-wrap "
      style="margin-bottom: 80px;margin-top: -90px;aspect-ratio: 220/100; padding-right: 0;top: 60px;    ">

      <div class="c-text-between c-flex-1 c-flex-wrap" style="position: relative;">

        <img src="@/assets/images/main/V1 Desktop.jpg" alt="" class="desktop-img"
          style="    height: 100%;width: 100%;position: absolute;">

        <img src="@/assets/images/main/V1 Mobile_1.jpg" alt="" class="px-container mobile-img"
          style="  width: 100%;aspect-ratio: 390/424; padding-left: 0; ">
        <div class=" index-width c-text-column" style="align-items: flex-start; justify-content: center;z-index: 2;">
          <h1 style="font-size: 45px;text-align: left;font-weight: 700">
            FRANKA RESEARCH 3 </h1>

          <span class="c-mt-5 c-mb-10 c-text-left ">Franka Research 3
            是一款世界领先的力敏感机器人系统，专为人工智能与机器人研究量身定制。它为研究人员提供易于使用的机器人功能，同时开放底层控制与学习能力接口，助力前沿探索。</span>
          <div class="c-text-justify-start c-flex-wrap">
            <!-- <div class="buttonSite" > -->
            <router-link to="/contact" class="buttonSite">联系我们</router-link>
            <!-- </div> -->
          </div>
        </div>
        <div class="c-flex-1 c-text-both">
        </div>
      </div>
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">关于Franka</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width">
        <img src="@/assets/images/main/_Frank Robotics0615_resized-1.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>赋能创新，推动机器人与人工智能不断发展</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">Franka
          Robotics是一家来自德国的技术驱动型机器人公司，总部位于慕尼黑，并在全球范围内运营。公司成立于2016年，自2023年以来加入Agile Robots SE集团。</span>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">
          我们的使命是赋能快速发展的机器人与人工智能专业社群，致力于为全球机器人与人工智能领域的前沿研究者提供研究平台。通过开放性的专业机器人平台与模块化设计的用户界面，助力科研机构与创新企业不断发展机器人及人工智能领域等技术，加速创新成果转化。
        </span>
        <span class="c-mt-5 c-mb-20 c-text-left text-indent">
          Franka Robotics致力于构建一个智能未来，让具备物理交互能力的AI系统深度融入人类生活场景，在医疗康养、智能制造、家庭服务等关键领域持续创造社会价值，为人类服务。
        </span>
        <div class="c-text-justify-start c-flex-wrap">
          <div class="buttonSite c-mr-20 c-mb-10">
            <a @click="$router.push('/company')">了解更多</a>
          </div>
        </div>
      </div>

    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">AI服务与即将推出的产品</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 80px;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>具身人工智能参考平台</h1>
        <span
          class="c-mt-5 c-mb-20 c-text-left text-indent">新一代机器人系统旨在支持从触觉遥操作到移动操控的物理智能研究。这些系统将为即将推出的人工智能服务提供支撑，包括大规模数据采集和现实世界学习功能。
        </span>
        <div class="c-text-justify-start c-flex-wrap">
          <div class="buttonSite c-mr-20 c-mb-10">
            <router-link to="/product-prototypes">探索最新动态</router-link>
          </div>
        </div>
      </div>

      <div class="display-width">
        <img src="@/assets/images/main/251105_MFR3_Duo_Camera01_01_fp.png" alt="" style="    height: auto; max-width: 100%;">
      </div>
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">公告</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 80px;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>思灵机器人的Diana7现全面适配FCI接口</h1>
        <span class="c-mt-5 c-mb-20 c-text-left text-indent">Franka Robotics 宣布，Agile Robots 的机器人 Diana 7 现在支持 Franka
          控制接口（FCI）。这一发展为其在研究和学术领域的应用铺平了道路。因此，Diana7的更高负载及更大工作范围完善了Franka的生态系统，与Franka Reseach 3相互补充，完善了产品矩阵及实际应用。
        </span>
        <div class="c-text-justify-start c-flex-wrap">
          <div class="buttonSite c-mr-20 c-mb-10">
            <router-link to="/products/diana-7">了解更多Diana 7</router-link>
          </div>
        </div>
      </div>

      <div class="display-width">
        <img src="@/assets/images/main/342295_154948_large_entry_medium.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    <!-- <div class="c-text-vBetween c-pos-relative"   @mouseenter="pauseSlider" 
    @mouseleave="startSlider">
      <transition name="fade" mode="out-in">
        <img
          :key="currentIndex"
          :src="currentImage"
          alt="轮播图片"
          class="carousel-image"
        />
      </transition>
    </div> -->

    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">来自Franka社区</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>社区亮点</h1>
        <span class="c-mt-10 c-mb-60 c-text-left ">来自Franka社区的一些亮点，包括机器人技术和人工智能领域的开创性研究、实际应用和教育资源。</span>
      </div>
    </div>
    <div class="px-container stress-content">
      <div v-for="(item, index) in contentList" :key="item.name + index" style="min-height: 180px; ">
        <!-- <div style="width: 100%;" class="c-text-both">
        <img :src="item.url" style="width: 100%;" />
        <div class="playButton ">
        </div>
      </div> -->
        <div style="aspect-ratio: 270/200;">
          <div style="width: 100%;" class="c-text-both" v-show="!item.iframeValue">
            <img :src="item.url" style="width: 100%;aspect-ratio: 270/200;" />
            <div class="playButton " @click="item.iframeValue = true">
            </div>
          </div>
          <iframe :src="item.videoUrl" v-if="item.iframeValue" width="100%" height="100%" frameborder="0" scrolling="no"
            allowfullscreen="true"></iframe>
        </div>
        <div class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
          {{ item.name }}
        </div>
        <div class="c-text-left c-width-precent-100">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div class="px-container company-content c-mt-40 c-mb-40 c-text-between">
      <div v-for="(item, index) in companyList" :key="item + index" class="c-text-both" style="min-height: 180px; ">
        <img :src="item" style="max-width: 100%;max-height: 100%;" />
      </div>
    </div>

  </div>
</template>

<script>

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },

  name: 'App',
  components: {
  },
  data() {
    return {
      timer: null,
      images: [
        require('@/assets/images/main/thumbnail_iREX banner.jpg'),
      ],
      currentIndex: 0,
      companyList: [
        //  require('@/assets/images/company/image 62.png'),
        require('@/assets/images/company/image 61.png'),
        require('@/assets/images/company/image 63.png'),
        // require('@/assets/images/company/image 64.png'),
        // require('@/assets/images/company/image 426.png'),
        // require('@/assets/images/company/image 65.png'),
        require('@/assets/images/company/image 68.png'),
        // require('@/assets/images/company/image.png'),
        require('@/assets/images/company/1741312443182.jpg'),
        require('@/assets/images/company/1741312479527.jpg'),
        require('@/assets/images/company/image 74.png'),
        require('@/assets/images/company/image 75-1.png'),
        require('@/assets/images/company/image 66.png'),
        require('@/assets/images/company/image 67.png'),
        require('@/assets/images/company/1741312517486.jpg'),
        require('@/assets/images/company/1741312537399.jpg'),
        require('@/assets/images/company/Toyota Research Institute Logo.png'),
        require('@/assets/images/company/University of York.png'),
        require('@/assets/images/company/image 69.png'),
        require('@/assets/images/company/image-1.png'),
        require('@/assets/images/company/image-2.png'),
        require('@/assets/images/company/image 73.png'),
        require('@/assets/images/company/5c4788f9b8f9a221f953451b9922c74.png'),

      ],
      contentList: [
        // {
        //   name: 'Meta',
        //   value: '推动机器人技术和触觉感知!',
        //   url: require('@/assets/images/main/hqdefault.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1hk9BYTEuw'
        // },
        {
          name: '丰田研究院',
          value: '机器人动作学习',
          url: require('@/assets/images/main/hqdefault (1).jpg'),
          iframeValue: false,
          videoUrl: 'https://player.bilibili.com/player.html?bvid=BV1Y696YjEkT'
        },
        // {
        //   name: '麻省理工学院',
        //   value: '机器人轨迹规划研究',
        //   url: require('@/assets/images/main/hqdefault (2).jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1GC96Y5E23'
        // },
        // {
        //   name: '清华大学',
        //   value: '从无法抓取的姿势中学习物体的预抓取操作',
        //   url: require('@/assets/images/main/hqdefault (3).jpg')
        // },
        // {
        //   name: 'DROID',
        //   value: '大规模野外机器人操作数据集',
        //   url: require('@/assets/images/main/hqdefault (4).jpg')
        // },
        // {
        //   name: '昆士兰科技大学',
        //   value: '动态环境中移动操作的反应式基础控制',
        //   url: require('@/assets/images/main/hqdefault (5).jpg')
        // },
        {
          name: '多伦多大学',
          value: '机器人助力自动化化学实验',
          url: require('@/assets/images/main/hqdefault (6).jpg'),
          iframeValue: false,
          videoUrl: 'https://player.bilibili.com/player.html?bvid=BV1GC96Y5Ed3'
        },
        {
          name: '德累斯顿工业大学',
          value: 'Franka机器人辅助手术 - 手术室人机交互',
          url: require('@/assets/images/main/hqdefault (7).jpg'),
          iframeValue: false,
          videoUrl: 'https://player.bilibili.com/player.html?bvid=BV1t396YKE99'
        },
        // {
        //   name: '斯坦福大学',
        //   value: 'Franka Robotics为李飞飞团队的研究开发提供平台！',
        //   url: require('@/assets/images/main/1741311387142.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1ZbHse1E48'
        // },
        // {
        //   name: '麻省理工大学',
        //   value: 'Franka Robotics携手麻省理工女博士为家用机器人的开发做出重要贡献，让人们远离家务的烦恼！',
        //   url: require('@/assets/images/main/1741311514704.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1pbw8epEDy'
        // },
        // {
        //   name: '卡耐基梅隆大学',
        //   value: 'Franka Research 3在卡内基梅隆大学发表的ManipGen框架的研究中起到了关键作用！',
        //   url: require('@/assets/images/main/1741311693730.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1Q5kMY9Ev5'
        // },
      ]
    }
  },

  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    }
  },
  mounted() {
    // this.startSlider();
  },
  beforeUnmount() {
    // this.pauseSlider();
  },
  methods: {
    startSlider() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.images.length;
        }, 5000);
      }
    },
    pauseSlider() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
</script>

<style>
/* 导航栏容器的样式 */
nav {
  color: #1B2F36;
  /* 背景色 */
}


/* 栅格布局，将 <ul> 设置为水平排列 */
ul.navbar {
  list-style-type: none;
  display: flex;
  padding: 10px;
}

/* 每个 <li> 的样式 */
ul.navbar li {
  position: relative;
  /* 相对定位，用于子菜单的绝对定位 */
  /* margin: 0 20px;   */
}

/* 链接的样式 */
ul.navbar li a {
  text-decoration: none;
  /* 去掉下划线 */
  font-size: 14px;
  padding: 10px 15px;
  /* 内边距 */
  display: block;
}

/* 子菜单（下拉菜单）样式 */
ul.dropdown-menu {
  /* border: 1px solid #1b2f364f; */
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
  list-style-type: none;
  position: absolute;
  /* 绝对定位 */
  top: 100%;
  /* 放置在父菜单项的下方 */
  /* left: 0; */
  background-color: white;
  /* 背景色 */
  display: none;
  /* 初始状态下隐藏 */
  width: 150px;
  /* 设置子菜单宽度 */
  border-radius: 5px;
  /* 圆角 */
  padding: 5px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);  */
}

.dropdown-menu:last-of-type {
  /* 在这里设置你需要的样式 */
  /* left: -40px;
    width: 130px; */
}

/* 子菜单项的样式 */
ul.dropdown-menu li a {
  padding: 10px 5px;
  color: #1B2F36;
  text-decoration: none;
  /* 去掉下划线 */
  display: block;
  text-align: left;
}

/* 子菜单项的悬停效果 */
ul.dropdown-menu li a:hover {
  background-color: #eef1f2;
}

/* 鼠标悬停时显示子菜单 */
ul.navbar li:hover>.dropdown-menu {
  display: block;
  /* 显示子菜单 */


}

/* 默认情况下，一行展示 4 个项目 */
.stress-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  /* 项目之间的间隔 */
}

.company-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.stress-content>div {
  width: calc(25% - 20px);
  /* 4 个项目 */
}

.company-content>div {
  width: calc(16.5% - 40px);
  /* 4 个项目 */
}

.display-width {
  width: calc(50% - 40px);
}

.ending-width {
  width: 35%;
}

.logo-alt {
  display: none;
  /* 默认隐藏 logo.svg */
}



.index-width {
  width: 33%;
}

/* 当屏幕宽度大于 1200px 时隐藏移动图片 */
@media (min-width: 1200px) {
  .mobile-img {
    display: none;
  }
}

/* 屏幕宽度小于 1200px 时，一行展示 3 个 */
@media (max-width: 1199px) {
  .stress-content>div {
    width: calc(33.33% - 20px);
    /* 3 个项目 */
  }

  .desktop-img {
    display: none;
  }

  .index-width {
    width: 100%;
    margin-top: -60px
  }

  .company-content>div {
    width: calc(25% - 40px);
    /* 3 个项目 */
  }

  .logo-main {
    display: none;
    /* 隐藏 logo-and-claim.svg */
  }

  .logo-alt {
    display: block;
    /* 显示 logo.svg */
  }
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .stress-content>div {
    width: calc(50% - 20px);
    /* 2 个项目 */
  }

  .company-content>div {
    width: calc(33% - 40px);
    /* 3 个项目 */
  }

  .display-width {
    width: 100%
  }

  .ending-width {
    width: 100%;
    margin-top: 40px;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .stress-content>div {
    width: 100%;
    /* 1 个项目 */
  }

  .company-content>div {
    width: calc(50% - 40px);
    /* 3 个项目 */
  }
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.carousel-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>